import { render, staticRenderFns } from "./syncOperate.vue?vue&type=template&id=289e7138&scoped=true"
import script from "./syncOperate.vue?vue&type=script&lang=js"
export * from "./syncOperate.vue?vue&type=script&lang=js"
import style0 from "./syncOperate.vue?vue&type=style&index=0&id=289e7138&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289e7138",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('289e7138')) {
      api.createRecord('289e7138', component.options)
    } else {
      api.reload('289e7138', component.options)
    }
    module.hot.accept("./syncOperate.vue?vue&type=template&id=289e7138&scoped=true", function () {
      api.rerender('289e7138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/indexes/sync/components/syncOperate.vue"
export default component.exports